<div class="icon-list">
    <mat-icon
        (click)="selectIcon(icon)"
        *ngFor="let icon of iconList"
        [class.active]="icon == activeIcon"
        >{{icon}}</mat-icon
    >
</div>
